import { Component } from '@angular/core'

@Component({
  selector: 'se-po-persona-eligibility-docs',
  templateUrl: './persona-eligibility-docs.component.html',
  standalone: false,
})
export class PersonaEligibilityDocsComponent {
  public models: string[]
  public headers: any = {
    PersonaEligibilityComponent: [
      'Property',
      'Type',
      'Description',
    ]
  }

  public rows: any = {
    PersonaEligibilityComponent: [
      {
        Property: '@Input() personaId',
        Type: 'number',
        Description: 'Persona ID',
      },
      {
        Property: '@Input() contextOrgId',
        Type: 'number',
        Description: 'Organization ID',
      },
      {
        Property: '@Input() eligibilityRuleSetIds',
        Type: 'string[] | null',
        Description: 'Eligibility Rule Set IDs',
      },
      {
        Property: '@Input() affiliationOrganizationId',
        Type: 'number | undefined',
        Description: 'Affiliation organization ID',
      }
    ]
  }

  constructor() {
    this.models = Object.keys(this.headers)
  }
}
